// Use env variable when provided, otherwise rely on relative /api
export const ApiURL = import.meta.env.VITE_API_URL || '/api';
